import { getData, postData } from "../common/Apicall";

export const allMainCategoryApi = () => {
  return getData(`/api/v1/category/getMainCategory`);
};

export const getSubChildCategories = (mainCategory) => {
  return postData(`/api/v1/category/getSubChildCategory`, {
    mainCategory,
  });
};

export const mainCategoryApi = () => {
  return getData("/api/v1/category/getMainCategory");
};

export const subChildCatergoryApi = (mainCategory) => {
  return postData("/api/v1/category/getSubChildCategory", { mainCategory });
};

export const allCategoryApi = () => {
  return getData("/api/products/allCategory");
};
